var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E1E6E9"
    },
    points: "234.146,114.829 172.977,16.269 183.395,10.502 234.146,90.25 284.897,10.502  295.315,16.269 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M234.146,83.842c-13.151,0-23.812,10.661-23.812,23.812h47.623 C257.958,94.503,247.297,83.842,234.146,83.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M40.676,414.508v35.925c0,9.863,7.996,17.859,17.859,17.859h351.223 c9.863,0,17.859-7.996,17.859-17.859v-35.925H40.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M444.894,441.018H23.399c-6.897,0-12.488-5.591-12.488-12.488V132.047 c0-6.897,5.591-12.488,12.488-12.488h421.494c6.897,0,12.488,5.591,12.488,12.488V428.53 C457.381,435.427,451.79,441.018,444.894,441.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M338.318,167.195v226.212c0,9.882-7.977,17.859-17.859,17.859H58.53 c-9.882,0-17.859-7.977-17.859-17.859V167.195c0-9.881,7.977-17.859,17.859-17.859h261.929 C330.341,149.336,338.318,157.314,338.318,167.195z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.738,
    y: 149.329,
    style: {
      fill: "#27A2DB"
    },
    width: 59.529,
    height: 261.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.233,
    y: 149.298,
    style: {
      fill: "#44C4A1"
    },
    width: 59.529,
    height: 261.932
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M100.2,149.336v261.929H58.53c-9.882,0-17.859-7.977-17.859-17.859V167.195 c0-9.881,7.977-17.859,17.859-17.859H100.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.242,
    y: 149.348,
    style: {
      fill: "#E56353"
    },
    width: 59.529,
    height: 261.932
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M338.318,167.195v226.212c0,9.882-7.977,17.859-17.859,17.859h-41.671V149.336h41.671 C330.341,149.336,338.318,157.314,338.318,167.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M433.565,214.884c0,17.264-12.263,31.67-28.514,35.004c-2.322,0.476-4.762,0.714-7.203,0.714 c-2.441,0-4.881-0.238-7.203-0.714c-16.252-3.334-28.515-17.74-28.515-35.004c0-17.323,12.263-31.669,28.515-35.003 c2.321-0.477,4.762-0.715,7.203-0.715c2.441,0,4.881,0.238,7.203,0.715C421.302,183.215,433.565,197.561,433.565,214.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M382.164,191.073l39.496,39.497c-1.041,1.578-2.284,3.089-3.661,4.467 c-1.377,1.377-2.888,2.62-4.466,3.661L374.036,199.2c1.041-1.579,2.283-3.09,3.66-4.467 C379.074,193.356,380.585,192.113,382.164,191.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 362.146,
    y: 292.152,
    style: {
      fill: "#D5D6DB"
    },
    width: 71.437,
    height: 8.929
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.146,
    y: 318.939,
    style: {
      fill: "#D5D6DB"
    },
    width: 71.437,
    height: 8.929
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.146,
    y: 345.719,
    style: {
      fill: "#D5D6DB"
    },
    width: 71.437,
    height: 8.929
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.146,
    y: 372.511,
    style: {
      fill: "#D5D6DB"
    },
    width: 71.437,
    height: 8.929
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M293.676,119.559H174.617v-5.371c0-6.897,5.591-12.488,12.488-12.488h94.083 c6.897,0,12.488,5.591,12.488,12.488V119.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#64798A"
    },
    cx: 289.355,
    cy: 13.393,
    r: 13.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#64798A"
    },
    cx: 178.95,
    cy: 13.393,
    r: 13.393
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.2486cd3bb95959e351b0a3b1d7be4896.svg";
export { ForwardRef as ReactComponent };